import { useRouter } from 'next/router';

import Link from '@/components/Link/Link';
import { useInteraction } from '@/hooks/useInteraction';

import useStyles from './BlogTag.styles';

interface BlogPillProps {
  category?: string | null;
  className?: string;
  path: string;
  renderAsDiv?: boolean;
}

export default function BlogTag({
  className,
  category,
  path,
  renderAsDiv,
}: BlogPillProps): React.JSX.Element {
  const { classes, cx } = useStyles();
  const router = useRouter();

  const tagClassName = cx(classes.tag, path && classes.link, className);

  const handleInteraction = useInteraction((event) => {
    router.push(path);
    event.stopPropagation();
  });

  const categoryProps = {
    className: tagClassName,
    role: 'button',
    tabIndex: 0,
    'data-testid': 'blogCategory',
    'aria-label': path ? `Navigate to ${path}` : category || '',
    onClick: handleInteraction,
    onKeyDown: handleInteraction,
  };

  if (renderAsDiv) {
    return <div {...categoryProps}>{category && <span>{category}</span>}</div>;
  }

  return (
    <Link href={path} className={tagClassName} data-testid='blogCategory'>
      {category && <span>{category}</span>}
    </Link>
  );
}
